export const ADDONS = [
  { id: "lemon", label: "Add in 1 lemon", price: 0.9 },
  { id: "ginger", label: "Add in ginger", price: 0.5 },
  { id: "mint", label: "Add in mint", price: 0.4 },
  { id: "kale", label: "Add in kale", price: 0.5 },
];

const V = (id, name, price) => ({ id, name, price });

export const VARIATION_GROUPS = [
  {
    base: "Watermelon",
    img: "/img/bottle_watermelon.webp",
    items: [
      V("watermelon", "Watermelon", 9.5),
      V("watermelon-ginger", "Watermelon Ginger", 10.0),
      V("watermelon-mint", "Watermelon Mint", 9.9),
      V("watermelon-ginger-mint", "Watermelon Ginger Mint", 10.4),
    ],
  },
  {
    base: "Pineapple",
    img: "/img/bottle_pineapple.webp",
    items: [
      V("pineapple", "Pineapple", 9.5),
      V("pineapple-watermelon", "Pineapple Watermelon", 11.0),
      V("pineapple-ginger", "Pineapple Ginger", 10.0),
      V("pineapple-mint", "Pineapple Mint", 9.9),
      V("pineapple-kale", "Pineapple Kale", 10.0),
      V("pineapple-ginger-mint", "Pineapple Ginger Mint", 10.4),
      V("pineapple-ginger-mint-watermelon", "Pineapple Ginger Mint Watermelon", 14.0),
    ],
  },
  {
    base: "Apple",
    img: "/img/bottle_apple.webp",
    items: [
      V("apple", "Apple", 6.5),
      V("apple-lemon", "Apple Lemon", 7.4),
      V("apple-mint", "Apple Mint", 6.9),
      V("apple-lemon-mint", "Apple Lemon Mint", 7.8),
    ],
  },
];

export const ALL_VARIATIONS = VARIATION_GROUPS.flatMap((g) =>
  g.items.map((i) => ({ ...i, img: g.img }))
);

export const FLAVORS = [
  {
    id: "watermelon",
    name: "Ruby Rind",
    fruit: "Fresh Watermelon",
    price: 9.5,
    img: "/img/bottle_watermelon.webp",
    bg: "#B5122F",
    text: "#FFF4D6",
    note: "Sun-split melon with a pinch of sea salt, pressed the day it's picked.",
    stats: ["Lycopene", "Citrulline", "Vitamins A & C"],
  },
  {
    id: "pineapple",
    name: "The sweetest",
    fruit: "Fresh Pineapple",
    price: 9.5,
    img: "/img/bottle_pineapple.webp",
    bg: "#FFD000",
    text: "#181203",
    note: "Ripe pineapple pressed at the peak of its sweetness.",
    stats: ["Bromelain", "Vitamin C", "Manganese"],
  },
  {
    id: "apple",
    name: "Orchard Amber",
    fruit: "Fresh Apples",
    price: 6.5,
    img: "/img/bottle_apple.webp",
    bg: "#6E3F12",
    text: "#FFF4D6",
    note: "Cloudless honeycrisp juice with a crisp, clean finish.",
    stats: ["Pectin fiber", "Polyphenols", "Heart-healthy"],
  },
  {
    id: "trio",
    name: "The Trio",
    fruit: "Watermelon · Pineapple · Apple",
    price: 22.0,
    img: null,
    bg: "#181203",
    text: "#FFD000",
    note: "One of each. The full SweetJuice spectrum in a single box.",
    stats: ["3 x 16oz", "All 3 flavors", "Gift-ready"],
  },
];

export const getVariation = (id) => ALL_VARIATIONS.find((v) => v.id === id);
export const getFlavor = (id) => FLAVORS.find((p) => p.id === id);
export const money = (n) => `$${(Number(n) || 0).toFixed(2)}`;
